import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

export const Breadcrumbs = ({ items }) => (
  <nav aria-label="Breadcrumb" data-testid="breadcrumbs" className="flex flex-wrap items-center gap-1.5 text-xs font-outfit text-faint">
    <Link to="/" data-testid="breadcrumb-home" className="inline-flex items-center gap-1 transition-colors hover:text-terra">
      <Home className="h-3.5 w-3.5" /> Home
    </Link>
    {items.map((item, i) => (
      <span key={i} className="inline-flex items-center gap-1.5">
        <ChevronRight className="h-3 w-3 text-ink/30" />
        {item.href && i < items.length - 1 ? (
          <Link to={item.href} data-testid={`breadcrumb-${i}`} className="transition-colors hover:text-terra">
            {item.label}
          </Link>
        ) : (
          <span data-testid={`breadcrumb-${i}`} className="font-medium text-plumsoft" aria-current="page">
            {item.label}
          </span>
        )}
      </span>
    ))}
  </nav>
);
